import { useState } from 'react';

interface CreateAccountState {
  isLoading: boolean;
  showPopoverError: boolean;
  extraError: Error | null;
  collectedData: {
    clinicName: string;
    displayName: string;
    email: string;
  } | null;
}
export function useFormState() {
  const [formState, setFormState] = useState<CreateAccountState>({
    isLoading: true,
    showPopoverError: false,
    extraError: null,
    collectedData: null
  });
  return { formState, setFormState };
}
